var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-350b4003.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-42970741.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M8.667.614v30.772c-.9-.17-1.692-.374-2.325-.616C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C6.975.988 7.767.783 8.667.614Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M23.334 31.4V.623c.909.174 1.711.387 2.357.64 4.447 1.728 5.476 6.646 5.476 6.646.664 2.757.863 5.582.83 8.107.033 2.493-.2 5.317-.863 8.108 0 0-1.029 4.918-5.477 6.646-.633.252-1.424.46-2.323.63Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M23.333.623V31.4c-2.072.39-4.718.576-7.333.599-2.615-.023-5.262-.224-7.334-.614V.614C10.738.224 13.386.024 16 0c2.61.023 5.252.223 7.333.623Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "m16 26.641 2.616-3.923L16 18.795l-2.615 3.923L16 26.64Zm3.051-4.795 2.616-3.923L19.05 14l-2.615 3.923 2.615 3.923Zm-6.102 0 2.615-3.923L12.95 14l-2.615 3.923 2.615 3.923Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagVct = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagVct_default = SvgFlagVct;
export {
  FlagVct_default as default
};
